import vSelect from 'vue-select'
import JsonExcel from 'vue-json-excel'
import Loading from './components/Loading.vue'
import Pending from './components/Pending.vue'
import Container from './components/Container.vue'
import Collapse from './components/Collapse.vue'
import LocationPicker from './components/LocationPicker.vue'
import FormInput from './components/Form/Input.vue'
import FormInputView from './components/Form/InputView.vue'
import FormTextarea from './components/Form/Textarea.vue'
import FormFile from './components/Form/File.vue'
import FormSelect from './components/Form/Select.vue'

import FormDatetime from './components/Form/Datetime.vue'
import FormSelectTable from './components/Form/SelectTable.vue'

import ReviewDataLine from './components/Review/DataLine.vue'
import ReviewFileLine from './components/Review/FileLine.vue'
import ReviewSection from './components/Review/Section.vue'

import FormApplicant from './components/Form/Applicant.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
	Vue.component('loading', Loading)
	Vue.component('pending', Pending)
	Vue.component('container', Container)
	Vue.component('collapse', Collapse)
	Vue.component('location-picker', LocationPicker)
	Vue.component('form-input', FormInput)
	Vue.component('form-inputview', FormInputView)
	Vue.component('form-textarea', FormTextarea)
	Vue.component('form-file', FormFile)
	Vue.component('form-select', FormSelect)
	Vue.component('form-datetime', FormDatetime)
	Vue.component('form-select-table', FormSelectTable)

	Vue.component('form-applicant', FormApplicant)
	
	Vue.component('review-dataline', ReviewDataLine)
	Vue.component('review-fileline', ReviewFileLine)
	Vue.component('review-section', ReviewSection)

	Vue.component('downloadExcel', JsonExcel)
	Vue.component('v-select', vSelect)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js